import { resetPrevNextButton } from "@modules/MediaSlider/styles";
import { ThemeUIStyleObject } from "theme-ui";

export const MainStyles: ThemeUIStyleObject = {
  minHeight: "700px",
  height: "100svh",
  maxHeight: ["calc(100svh - 15px)", "calc(100svh - 30px)"],
  overflow: "hidden",
  position: "relative",
  textAlign: "center",
  ".swiper-container": {
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: "5",
  },
  ".swiper-container .swiper-container": {
    top: 0,
    left: 0,
  },
  ".swiper-slide": {
    backgroundColor: "darkGreen",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
  },
  ".swiper-slide .swiper-slide": {
    justifyContent: "flex-end",
  },
  ...resetPrevNextButton,
  ".swiper-button-prev, .swiper-button-next": {
    background: "none",
    outline: "none",
    width: "auto",
    height: "auto",
    top: "auto",
    bottom: [5, 4, "50%"],
    transform: [null, null, "translateY(50%)"],
    marginTop: 0,
    borderRadius: "50%",
    border: "1px solid rgba(0,0,0, 0)",
    "&:hover, &:focus": {
      boxShadow: "none",
      "svg circle": {
        opacity: 0.5,
      },
    },
  },
  ".swiper-button-prev": {
    left: [4, 7],
  },
  ".swiper-button-next": {
    right: ["auto", 7],
    left: [14, "auto"],
  },
  ".swiper-pagination": {
    position: "absolute",
    display: "flex",
    px: [2, 17, 17],
    boxSizing: "border-box",
    justifyContent: "center",
    width: "100%",
    height: "24px",
    bottom: [2, 8, 13],
    "@media (min-resolution: 125dpi) and (orientation: landscape)": {
      bottom: [2, 4, 8],
    },
  },
  ".swiper-pagination-bullet": {
    position: "relative",
    maxWidth: [null, "90px", "90px"],
    flexBasis: [null, "90px", "90px"],
    height: "24px",
    bg: "transparent",
    flexGrow: 1,
    borderRadius: 0,
    opacity: 0.3,
    mx: 1,
  },
  ".swiper-pagination-bullet:after": {
    content: '""',
    height: "3px",
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    bg: "white",
  },
  ".swiper-pagination-bullet-active": {
    bg: "transparent",
    opacity: 1,
  },
};

export const ContainerStyles: ThemeUIStyleObject = {
  color: "white",
  height: "100%",
  width: "100%",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "center",
  pt: ["17.0rem", 20, 20],
  pb: [15, 13, 13],
  maxWidth: "100%",
};

export const OverflowBox: ThemeUIStyleObject = {
  overflowY: ["auto", "visible"],
  overflowX: ["hidden", "visible"],
  WebkitOverflowScrolling: "touch",
  maxHeight: "100%",
  width: "100%",
  maxWidth: "width.3",
  py: "10px",
};

export const HeadingStyles: ThemeUIStyleObject = {
  marginBottom: 7, //[7, 7, 11],
  fontSize: "h3", //["h3", "h2", "h1"],
  "@media (min-width: 576px)": {
    fontSize: "h2",
  },
  "@media (min-width: 1040px)": {
    fontSize: "h1",
    marginBlock: 11,
  },
  "@media (min-width: 576px) and (max-height: 800px) and (-webkit-min-device-pixel-ratio: 1.25) and (min-resolution: 120dpi)":
    {
      fontSize: "h3",
    },
  "@media (min-width: 1040px) and (max-height: 800px) and (-webkit-min-device-pixel-ratio: 1.25) and (min-resolution: 120dpi)":
    {
      fontSize: "h4",
      marginBlock: 7,
    },
};
export const LargeContentTextStyles: ThemeUIStyleObject = {
  p: {
    fontFamily: "heading",
    fontSize: "paragraphMedium", //[("paragraphMedium", "h4")],
    "@media (min-width: 1040px)": {
      fontSize: "h4",
    },
    "@media (min-width: 576px) and (max-height: 800px) and (-webkit-min-device-pixel-ratio: 1.25) and (min-resolution: 120dpi)":
      {
        fontSize: "paragraphMedium",
      },
    // "@media (min-width: 1040px) and (max-height: 800px) and (-webkit-min-device-pixel-ratio: 1.25) and (min-resolution: 120dpi)":
    //   {
    //     fontSize: "paragraphMedium",
    //   },
  },
};
export const TwoColumnsContentStyles: ThemeUIStyleObject = {
  textAlign: "left",
  p: {
    fontSize: "paragraphSmall",
    "&:last-of-type": {
      mb: 0,
    },
  },
};

export const StorySectionsStyles: ThemeUIStyleObject = {
  height: "100%",
  position: "relative",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "space-between",
  backgroundColor: "darkGreen",
  transition: "opacity .3s ease-in-out",
};

export const ThumbnailContainerStyles: ThemeUIStyleObject = {
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  pt: [17, 20, 20],
  textAlign: "center",
  color: "white",
  position: "relative",
};
export const ThumbnailsStyles: ThemeUIStyleObject = {
  "> .swiper-container": {
    maxWidth: "100vw",
    width: "100%",
    height: "auto",
    position: "relative",
    top: "auto",
    left: "auto",
    display: "inline-flex",
    pt: 1,
    bg: "transparent",
    zIndex: 10,
  },
  "> .swiper-container .swiper-slide": {
    bg: "transparent",
    display: "inline-block",
    px: [1, 4],
    flexShrink: 0,
    textAlign: "center",
    width: ["50px", "70px"],
    height: "auto",
    position: "relative",
  },
};
export const ThumbnailButtonStyles: ThemeUIStyleObject = {
  width: "100%",
  height: "100%",
  borderRadius: "50%",
  overflow: "hidden",
  margin: "0 auto",
  position: "relative",
  padding: 0,
  cursor: "pointer",
  bg: "rgba(222, 198, 115, 0.3)",
  "&:after": {
    content: "''",
    position: "absolute",
    top: "50%",
    left: "50%",
    zIndex: "1",
    width: "80%",
    height: "80%",
    borderRadius: "50%",
    border: "2px solid white",
    transform: "translate(-50%, -50%)",
    transition: "opacity 0.3s",
    opacity: 0,
  },
  "&:hover, &:focus": {
    boxShadow: "none",
    "&:after": { opacity: 1 },
  },
};
export const ThumbnailButtonSelectedStyles: ThemeUIStyleObject = {
  "&:after": { opacity: 1 },
};
export const SectionTitleStyles: ThemeUIStyleObject = {
  fontSize: "xsText",
  textTransform: "uppercase",
  mt: 3,
};

export const ExploreButtonWrapperStyles: ThemeUIStyleObject = {
  position: "absolute",
  bottom: [10, null, 13],
  left: 0,
  width: "100%",
  textAlign: "center",
};

export const MobileLandscapeStyles: ThemeUIStyleObject = {
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 20,
  width: "100%",
  height: "100%",
  display: "none",
  bg: "darkGreen",
  "@media screen and (max-height: 35.0rem) and (orientation: landscape)": {
    display: "block",
  },
};
export const MobileLandscapeContentStyles: ThemeUIStyleObject = {
  pt: 17,
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "white",
  margin: "0 auto",
  maxWidth: "width.0",
  flexDirection: "column",
  svg: {
    width: "80px",
    height: "80px",
    stroke: "white",
  },
};
